import React, { createContext, useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";
import { useLocation } from "react-router-dom";
import qs from "qs";
import featuresStore from "@app/state/store/features";
import applicationStore from "@app/state/store/application";
import profile from "@app/state/store/profile";

import "./style/full-page.scoped.scss";

// Holds the layout root element, used as the container of floating overlays (eg: the global chat)
export const FullPageContainerContext = createContext(null);

const FullPageLayout = observer(({ children }) => {
    const { search } = useLocation();
    const rootRef = useRef(null);
    const [container, setContainer] = useState(null);

    const urlParams = qs.parse(search, {
        ignoreQueryPrefix: true,
    });

    useEffect(() => {
        featuresStore.setFeaturesInSession(urlParams.features);
        applicationStore.load();
        profile.load();
    }, []);

    useEffect(() => {
        setContainer(rootRef.current);
    }, []);

    return (
        <div className="layout fullPage" ref={rootRef}>
            <div className="body">
                <div className="content">
                    <FullPageContainerContext.Provider value={container}>
                        {children}
                    </FullPageContainerContext.Provider>
                </div>
            </div>
        </div>
    );
});

export default FullPageLayout;
